
import XTable from 'vux/src/components/x-table/index.vue'

export default {
name: 'Orbital_sarcoma',
components: {
XTable
}
}



// WEBPACK FOOTER //
// ./src/pages/formulas/Onco/Orbital_sarcoma.vue